import { captureException } from "@sentry/react";
import { AxiosInstance } from "axios";
import { Dispatch } from "redux";
import { IStateTree } from "../../interfaces";
import { showNotification } from "../../notification/actions";
import { PackActionTypes } from "../models/packActions";

import { RENAME_PLAN } from "../types";

export default (data: { planId: string, name: {[lang: string]: string}}, callback: (res: boolean) => void) => async (dispatch: Dispatch<PackActionTypes>, getState: () => IStateTree, api: AxiosInstance) => {
    try {
        await api.post("/rename-plan", data);
        dispatch({
            type: RENAME_PLAN,
            payload: { data },
        });
        callback(true);
    } catch (error) {
        callback(false);
        dispatch(showNotification(error.toString(), "warning"));
        captureException(error);
    }
};